import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Container,
  Stack,
} from "@mui/material";
import hydImg from "../Assets/images/hyd.jpeg";
import biryaniImg from "../Assets/images/biryani.jpeg";
import useMediaQuery from "@mui/material/useMediaQuery";
import sfoImg from "../Assets/images/sfo.jpeg";
import freshImg from "../Assets/images/fresh.jpeg";
import halalImg from "../Assets/images/halal.png";
import SEO from "../Common/SEO";

const bagaraVideo = `${process.env.PUBLIC_URL}/bagaras_insta.mp4`;
const bagaraPoster = `${process.env.PUBLIC_URL}/bagaras_poster.jpg`;

const Home = () => {
  const matches = useMediaQuery("(min-width:600px)");
  return (
    <div>
      <SEO
        title="Bagara's - Hyderabadi Biryani & Indian Food | Sunnyvale, CA"
        description="Best Indian restaurant in Sunnyvale & Bay Area. Authentic Hyderabadi dum biryani, bagara rice, gobi 65, chicken 555 & Telugu curries. Halal certified."
        canonical="https://bagaras.com/"
        keywords="best Indian restaurant Sunnyvale, best Indian food Bay Area, best biryani near me, Hyderabadi biryani Sunnyvale, Hyderabadi biryani San Jose, Hyderabadi biryani Santa Clara, Hyderabadi biryani Cupertino, Hyderabadi biryani Mountain View, Hyderabadi biryani Palo Alto, Hyderabadi biryani Fremont, Hyderabadi biryani Milpitas, Telugu food near me, Indian lunch Sunnyvale, Indian dinner San Jose, Indian breakfast Bay Area, best chicken biryani, best mutton biryani, gobi 65, chicken 555, chicken 65, mutton ghee roast biryani, karvepaku chicken roast, guthivankaya bagara, bagara rice, chili paneer, cut mirchi, masala mirchi bajji, kaaram samosa, mushroom fry, pepper baby corn, anda masala, kaju chicken pakoda, boneless fish pakoda, shrimp 65, andhra chicken curry, telangana mutton curry, meghana chicken fry piece biryani, paneer biryani, egg biryani, shrimp biryani, mixed vegetable biryani, jeera rice, mint rice, gongura rice, sambar rice, curd rice, poori with chicken curry, poori with mutton curry, shahi ka tukda, royal falooda, gulab jamun, mango lassi, irani chai, halal Indian food, Indian food delivery, Indian takeout"
      />
      {/* SEO content — visually hidden but indexable by search engines */}
      <Container
        sx={{
          position: "absolute",
          width: "1px",
          height: "1px",
          padding: 0,
          margin: "-1px",
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          borderWidth: 0,
        }}
      >
        <Typography variant="h3" component="h1" sx={{ fontWeight: "bold", color: "#20141e", mb: 1 }}>
          Bagara's — Authentic Hyderabadi Biryani &amp; Indian Food in Sunnyvale
        </Typography>
        <Typography variant="body1" component="p" sx={{ color: "#20141e", mb: 2, textAlign: "left" }}>
          Welcome to Bagara's, the best Indian restaurant in Sunnyvale and the Bay Area. We specialize in
          authentic Hyderabadi dum biryani, flavorful bagara rice, and traditional Telugu home-style curries.
          Our menu features beloved favorites like chicken dum biryani, mutton ghee roast biryani, gobi 65,
          chicken 555, karvepaku chicken roast, guthivankaya bagara, and much more. Every dish is prepared
          fresh daily with hand-ground spices and 100% halal meat sourced from trusted local suppliers.
        </Typography>
        <Typography variant="body1" component="p" sx={{ color: "#20141e", mb: 2, textAlign: "left" }}>
          Whether you are craving a hearty Hyderabadi biryani for lunch, a spicy Andhra chicken curry for
          dinner, or a comforting breakfast of poori with mutton curry, Bagara's has something for everyone.
          We also offer specialty rice dishes like jeera rice, gongura rice, mint rice, and sambar rice. Pair
          your meal with our handcrafted mango lassi or finish with our signature shahi ka tukda dessert.
        </Typography>
        <Typography variant="body1" component="p" sx={{ color: "#20141e", mb: 2, textAlign: "left" }}>
          Bagara's proudly serves customers across Sunnyvale, San Jose, Santa Clara, Cupertino, Mountain View,
          Palo Alto, Fremont, Milpitas, Campbell, Saratoga, Los Gatos, and the greater Bay Area. We offer
          dine-in, takeout, and delivery options for your convenience. Planning a party or corporate event?
          Our Indian catering service brings the same authentic flavors to your gathering, with customizable
          menus for groups of any size.
        </Typography>
        <Typography variant="body1" component="p" sx={{ color: "#20141e", mb: 2, textAlign: "left" }}>
          At Bagara's, we blend the culinary traditions of Hyderabad with the innovation of the Bay Area.
          Founded by Hyderabadi food enthusiasts and experienced Bay Area tech professionals, we understand
          the importance of quality, consistency, and a welcoming dining experience. Visit us at 594 East
          El Camino Real, Sunnyvale, CA 94087 and taste the difference that fresh ingredients and authentic
          recipes make.
        </Typography>
      </Container>

      {matches ? (
        <>
          <video
            height="980"
            controls
            autoPlay={true}
            loop={true}
            muted
            playsInline
            preload="none"
            poster={bagaraPoster}
            style={{ width: "100%", objectFit: "cover", top: 0, left: 0, paddingTop: "100px" }}
          >
            <source src={bagaraVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <Container sx={{ marginTop: "1em" }}>
            <Stack direction="column" spacing={2}>
              <Card sx={{ display: "flex" }}>
                <CardMedia
                  component="img"
                  sx={{ width: "50%" }}
                  image={sfoImg}
                  alt="Bay Area food enthusiasts and Hyderabadi chefs at Bagara's"
                  loading="lazy"
                />
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <CardContent sx={{ flex: "1 1 auto" }}>
                    <Typography
                      component="h2"
                      variant="h4"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                        color: "#20141e",
                      }}
                    >
                      Bay Area Foodies &amp; Hyderabadi Chefs
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="p"
                      sx={{
                        color: "#20141e",
                        textAlign: "left",
                        fontStyle: "italic",
                        fontSize: "1.2em",
                        marginTop: "2em",
                      }}
                    >
                      We are Hyderabadi's at heart and experienced Bay Area Big
                      Tech software engineers, we aim to provide a unique and
                      authentic dining experience balancing the needs of every
                      customer. Bagara's brings the rich culinary heritage,
                      offers a delightful array of authentic homestyle cooked
                      food. Served fresh and with utmost care, these dishes
                      showcase the vibrant flavors of the region. With a
                      commitment to using 100% halal meat, every bite is a
                      testament to the city's authentic and flavorful cuisine.
                    </Typography>
                  </CardContent>
                </Box>
              </Card>
              <Card sx={{ display: "flex" }}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <CardContent sx={{ flex: "1 0 auto" }}>
                    <Typography
                      component="h2"
                      variant="h5"
                      sx={{ color: "#20141e" }}
                    >
                      Mandi &amp; Biryani
                    </Typography>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{
                        color: "#20141e",
                        textAlign: "left",
                        marginTop: "2em",
                      }}
                    >
                      Indulge in the aromatic mandi, a traditional rice dish
                      cooked with tender meat, or explore the diverse culinary
                      experiences that Hyderabad has to offer.
                    </Typography>
                    <img
                      src={halalImg}
                      width="80"
                      height="65"
                      style={{ margin: "1em 1em 4em 10em" }}
                      alt="100% halal certified meat at Bagara's"
                      loading="lazy"
                    />
                    <Typography
                      component="h3"
                      variant="h5"
                      sx={{ color: "#20141e" }}
                    >
                      100 % Halal
                    </Typography>
                    <Typography
                      variant="body1"
                      component="p"
                      sx={{
                        color: "#20141e",
                        textAlign: "left",
                        marginTop: "2em",
                      }}
                    >
                      we proudly serve 100% authentic halal meat, sourced from
                      trusted suppliers and prepared according to strict Islamic
                      dietary laws. This ensures that every bite is a testament
                      to our dedication to quality and authenticity. Indulge in
                      the tender, flavorful meat that accompanies our delectable
                      dishes, knowing that your meal is prepared with the utmost
                      care and respect for tradition.
                    </Typography>
                  </CardContent>
                </Box>
                <CardMedia
                  component="img"
                  sx={{ width: "50%" }}
                  image={biryaniImg}
                  alt="Hyderabadi dum biryani served at Bagara's"
                  loading="lazy"
                />
              </Card>
              {/* <Card sx={{ display: "flex" }}>
                <CardMedia
                  component="img"
                  sx={{ width: "50%" }}
                  image={hydImg}
                  alt="Live from space album cover"
                />
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <CardContent sx={{ flex: "1 1 auto" }}>
                    <Typography
                      component="div"
                      variant="h4"
                      sx={{
                        diaply: "flex",
                        textAlign: "center",
                        color: "#20141e",
                      }}
                    >
                      Hyderabadi Heritage
                    </Typography>
                    <Typography
                      variant="body1"
                      component="p"
                      sx={{
                        color: "#20141e",
                        textAlign: "left",
                        fontStyle: "italic",
                        marginTop: "2em",
                      }}
                    >
                      Bagara's brings the rich culinary heritage, offers a
                      delightful array of authentic homestyle cooked food.
                      Served fresh and with utmost care, these dishes showcase
                      the vibrant flavors of the region. With a commitment to
                      using 100% halal meat, every bite is a testament to the
                      city's authentic and flavorful cuisine.
                    </Typography>
                  </CardContent>
                </Box>
              </Card> */}
              <Card sx={{ display: "flex" }}>
                <CardMedia
                  component="img"
                  sx={{ width: "50%" }}
                  image={freshImg}
                  alt="Fresh ingredients and spices used at Bagara's"
                  loading="lazy"
                />
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <CardContent sx={{ flex: "1 0 auto" }}>
                    <Typography
                      component="h2"
                      variant="h4"
                      sx={{ color: "#20141e" }}
                    >
                      Freshness &amp; Quality
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      sx={{
                        color: "#20141e",
                        textAlign: "left",
                        fontStyle: "italic",
                        fontSize: "1.2em",
                        marginTop: "2em",
                      }}
                    >
                      We pride ourselves on our vast array of dishes, combining
                      various herbs & spices which create tastes and aromas that
                      are diverse and unusual, from fiery hot to delicately
                      sublime. With mild to hot curries and lightly spiced as
                      well as more about flavours, the menu will appeal to all
                      connoisseurs of this traditional cuisine. All our dishes
                      are made using only the finest ingredients. We use real,
                      fresh, traditional spice, the best vegetables, seafood and
                      the freshest cuts of meat.
                    </Typography>
                  </CardContent>
                </Box>
              </Card>
            </Stack>
          </Container>
        </>
      ) : (
        <>
          <video
            height={800}
            controls
            autoPlay={true}
            loop={true}
            playsInline
            muted
            preload="none"
            poster={bagaraPoster}
            id="video"
            style={{ width: "100%", objectFit: "cover", margin: "0 auto", top: 0, left: 0, paddingTop: "140px" }}
          >
            <source src={bagaraVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <Container sx={{ marginTop: "1em" }}>
            <Stack direction="column" spacing={2}>
              <Card sx={{ maxWidth: 345 }}>
                <CardMedia
                  component="img"
                  sx={{ height: 360 }}
                  image={sfoImg}
                  alt="biryani Image"
                />
                <CardContent>
                  <Typography
                    sx={{ textAlign: "center" }}
                    gutterBottom
                    variant="h5"
                    component="h2"
                    color="#20141e"
                  >
                    Bay Area Foodies &amp; Hyderabadi Chefs
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    sx={{
                      color: "#20141e",
                      textAlign: "left",
                      marginTop: "2em",
                    }}
                  >
                    We are Hyderabadi's at heart and experienced Bay Area Big
                    Tech software engineers, we aim to provide a unique and
                    authentic dining experience balancing the needs of every
                    customer. Bagara's brings the rich culinary heritage, offers
                    a delightful array of authentic homestyle cooked food.
                    Served fresh and with utmost care, these dishes showcase the
                    vibrant flavors of the region. With a commitment to using
                    100% halal meat, every bite is a testament to the city's
                    authentic and flavorful cuisine.
                  </Typography>
                </CardContent>
              </Card>

              <Card sx={{ maxWidth: 345 }}>
                <CardMedia
                  sx={{ height: 360 }}
                  component="img"
                  image={halalImg}
                  alt="Hyderabad Image"
                />
                <CardContent>
                  <Typography component="h3" variant="h5" color="#20141e">
                    100 % Halal
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    sx={{
                      color: "#20141e",
                      textAlign: "left",
                      marginTop: "2em",
                    }}
                  >
                    we proudly serve 100% authentic halal meat, sourced from
                    trusted suppliers and prepared according to strict Islamic
                    dietary laws. This ensures that every bite is a testament to
                    our dedication to quality and authenticity. Indulge in the
                    tender, flavorful meat that accompanies our delectable
                    dishes, knowing that your meal is prepared with the utmost
                    care and respect for tradition.
                  </Typography>
                </CardContent>
              </Card>

              <Card sx={{ maxWidth: 345 }}>
                <CardMedia
                  sx={{ height: 360 }}
                  component="img"
                  image={biryaniImg}
                  alt="biryani Image"
                />
                <CardContent>
                  <Typography
                    sx={{ textAlign: "center" }}
                    gutterBottom
                    variant="h5"
                    component="h2"
                    color="#20141e"
                  >
                    Mandi &amp; Biryani
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    sx={{
                      color: "#20141e",
                      textAlign: "left",
                      marginTop: "2em",
                    }}
                  >
                    Indulge in the aromatic mandi, a traditional rice dish
                    cooked with tender meat, or explore the diverse culinary
                    experiences that Hyderabad has to offer.
                  </Typography>
                </CardContent>
              </Card>
              <Card sx={{ maxWidth: 345 }}>
                <CardMedia
                  sx={{ height: 360 }}
                  component="img"
                  image={freshImg}
                  alt="Hyderabad Image"
                />
                <CardContent>
                  <Typography
                    sx={{ textAlign: "center" }}
                    gutterBottom
                    variant="h5"
                    component="h2"
                    color="#20141e"
                  >
                    Freshness &amp; Quality
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    sx={{
                      color: "#20141e",
                      textAlign: "left",
                      marginTop: "2em",
                    }}
                  >
                    We pride ourselves on our vast array of dishes, combining
                    various herbs & spices which create tastes and aromas that
                    are diverse and unusual, from fiery hot to delicately
                    sublime. With mild to hot curries and lightly spiced as well
                    as more about flavours, the menu will appeal to all
                    connoisseurs of this traditional cuisine. All our dishes are
                    made using only the finest ingredients. We use real, fresh,
                    traditional spice, the best vegetables, seafood and the
                    freshest cuts of meat.
                  </Typography>
                </CardContent>
              </Card>
              <Card sx={{ maxWidth: 345 }}>
                <CardMedia
                  sx={{ height: 360 }}
                  component="img"
                  image={hydImg}
                  alt="Hyderabad Image"
                />
                <CardContent
                  sx={{ justifyContent: "center", alignContent: "center" }}
                >
                  <Typography
                    sx={{ textAlign: "center" }}
                    gutterBottom
                    variant="h5"
                    component="h2"
                    color="#20141e"
                  >
                    Hyderabadi Heritage
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    sx={{
                      color: "#20141e",
                      textAlign: "left",
                      marginTop: "2em",
                    }}
                  >
                    Bagara's brings the rich culinary heritage, offers a
                    delightful array of authentic homestyle cooked food. Served
                    fresh and with utmost care, these dishes showcase the
                    vibrant flavors of the region. With a commitment to using
                    100% halal meat, every bite is a testament to the city's
                    authentic and flavorful cuisine.
                  </Typography>
                </CardContent>
              </Card>
            </Stack>
          </Container>
        </>
      )}
    </div>
  );
};

export default Home;
